var onEnterPress = function onEnterPress(callback) {
  return function (event) {
    if (event.key === 'Enter') {
      callback(event);
    }
  };
};
export default onEnterPress;